import React, { PureComponent, PropTypes } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Input, TextArea, Checkbox } from '../../components/Form';
import Alert from '../../components/Form/Alert';
import { createValidator, required, isTrue, minLength } from '../../components/Form/validators';
import { Link } from 'react-router-dom'


class CheckoutForm extends PureComponent {
  render() {
    const { handleSubmit, invalid, error, submitting } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        {error && <Alert>{error}</Alert>}
        <fieldset className="form-group">
          <Field component={Input} name="campaignName" label="Kampaņas nosaukums" />
          <Field component={TextArea} name="notes" label="Piezīmes" />
          <Field
            component={Checkbox}
            name="agree"
            ommitGroupLabel
            label={<span>Piekrītu <Link to="/tos" target="_blank">noteikumiem</Link></span>}
            group={{fieldClass: "col-sm-9 offset-sm-3"}}
          />
        </fieldset>
        <button 
          className="btn pull-right btn-primary btn-lg"
          disabled={invalid || submitting }
          type="submit"
        >
          Noformēt pasūtījumu
        </button>        
      </form>      
    )
  }
}

const validate = createValidator({
  campaignName: [required, minLength(6)],
  agree: [required, isTrue]
});

export default reduxForm({
  form: 'checkout',
  validate,
})(CheckoutForm);


// WEBPACK FOOTER //
// ./src/scenes/Checkout/Form.js